import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing }) => ({
  button: {
    cursor: "pointer",
    display: "flex",
  },
  button_text: {
    fontSize: 16,
    fontWeight: 500,
  },
  menu: {
    "& .MuiMenu-paper": {
      border: "1px solid #E0E2E6",
      borderRadius: spacing(1),
      boxShadow: "0px 2px 4px 0px #00000029 !important",
    },
    marginTop: spacing(1),
  },
  menu__item: {},
  title: {
    color: "#757575",
    fontSize: 16,
    fontWeight: 400,
    marginRight: spacing(0.5),
    whiteSpace: "nowrap",
  },
}));
